import { Dialog } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import icClose from 'Assets/img/ic_x_circle.png';
import icClose2 from 'Assets/img/ic_x_circle@2x.png';
import icClose3 from 'Assets/img/ic_x_circle@3x.png';
import icSearch from 'Assets/img/contract/ic_search.png';
import icSearch2 from 'Assets/img/contract/ic_search@2x.png';
import icSearch3 from 'Assets/img/contract/ic_search@3x.png';
import { getImageSet } from 'Util/DataUtils';
import IntlMessages from 'Util/IntlMessages';
import { useIntl } from 'react-intl';
import { getTMapAddress } from 'Api/endpoints/Common';
import _ from 'lodash';
import { useError } from 'Api/hooks/useError';

const closeButtons = getImageSet([icClose, icClose2, icClose3]);
const searchButtons = getImageSet([icSearch, icSearch2, icSearch3]);
const AddressNewPopup = ({ open, onClose, onSelect }) => {
  const { showErrorPopup } = useError();
  const { formatMessage } = useIntl();
  const [searchKeyword, setSearchKeyword] = useState('');
  const [data, setData] = useState([]);
  const [debouncedText, setDebouncedText] = useState('');

  useEffect(() => {
    if (open) {
      setSearchKeyword('');
      setData([]);
    }
  }, [open]);

  const debouncedSearchText = useCallback(
    _.debounce(value => setDebouncedText(value), 300),
    []
  );

  useEffect(() => {
    debouncedSearchText(searchKeyword);
  }, [searchKeyword, debouncedSearchText]);

  const onClickSearch = useCallback(async () => {
    if (debouncedText === '' || debouncedText.length < 2) {
      setData([]);
      return null;
    }
    try {
      const result = await getTMapAddress({
        searchKeyword: debouncedText,
      });
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message, onClose });
        return;
      }
      setData(result.data);
    } catch (e) {
      console.log(e);
    }
  }, [debouncedText]);

  useEffect(() => {
    onClickSearch();
  }, [onClickSearch]);

  const onSelectItem = (item, isNew) => {
    const data = {
      address: item.address,
      address2: item.address2,
      latitude: item.latitude,
      longitude: item.longitude,
    };
    if (isNew) {
      data.address = item.addressNew;
      data.address2 = item.addressNew2;
    }
    onSelect(data);
    onClose();
  };

  const renderEmptyExample = index => {
    return (
      <div className="example-content-wrapper" key={`empty_${index}`}>
        <div className="example-content-title">
          <IntlMessages id={`address.popup.empty.example.title.${index}`} />
        </div>
        <div className="example-content-sub">
          <IntlMessages id={`address.popup.empty.example.sub.${index}`} />
        </div>
      </div>
    );
  };

  const renderDataList = (item, index) => {
    const { address, address2, addressNew, addressNew2 } = item;
    return (
      <div key={`list_${index}`} className="main-wrapper">
        <div className="address-main" onClick={() => onSelectItem(item, false)}>
          <div className="main-title">
            <IntlMessages id="address.type.old" />
          </div>
          <div className="main-contents">
            {address} {address2}
          </div>
        </div>
        <div className="address-main" onClick={() => onSelectItem(item, true)}>
          <div className="main-title">
            <IntlMessages id="address.type.new" />
          </div>
          <div className="main-contents">
            {addressNew} {addressNew2}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Dialog fullWidth={true} maxWidth="small" onClose={null} open={open}>
      <div className="address-popup">
        <div className="address-popup-header">
          <div className="popup-header-title">
            <IntlMessages id="button.searchAddress" />
          </div>
          <div className="address-popup-search-wrapper">
            <div className="address-popup-search-input">
              <input
                type="text"
                placeholder={formatMessage({ id: 'address.popup.search.placeholder' })}
                value={searchKeyword}
                onChange={({ target: { value } }) => setSearchKeyword(value)}
                autoFocus
              />
            </div>
            <div className="address-popup-search-button-wrapper">
              <img className="address-popup-search-button" {...searchButtons} alt="search" />
            </div>
          </div>
        </div>
        <div className="close-button">
          <img {...closeButtons} alt="close" onClick={onClose} />
        </div>
        {data.length === 0 ? (
          <div className="address-popup-main-empty">
            <div className="address-popup-main-empty-title">
              <IntlMessages id="address.popup.empty.title" />
            </div>
            <div className="address-popup-main-empty-sub">
              <IntlMessages id="address.popup.empty.sub" />
            </div>
            <div className="address-popup-main-empty-example-wrapper">{[1, 2].map(renderEmptyExample)}</div>
          </div>
        ) : (
          <div className="address-popup-main">
            <div className="address-popup-main-wrapper">{data.map(renderDataList)}</div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AddressNewPopup;
